export enum EJointCapable {
    Joint_Anchor,   // 锚点
    Joint_ConnectAnchor,    // 链接锚点
}